module.exports = __webpack_public_path__ + "img/settings-color.dae96f82.png";